<template>
  <div>
    <section style="background-color: #172b4d">
      <div>
        <div
          v-show="this.$store.state.layout === 'default'"
          class="min-height-300 position-absolute w-100 bg-success"
        />
      </div>

      <div class="py-1 container vh-100">
        <main class="main-content mt-0">
          <div class="page-header align-items-center pb-11 m-3 border-radius-lg">
            <h3 class="text-white mx-auto">Izin Stasiun Radio</h3>
          </div>
          <div class="container">
            <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
              <div class="col-xl-6 col-lg-6 col-md-6 mx-auto">
                <div class="card z-index-0">
                  <div class="card-body p-6">
                    <div class="text-center">
                      <h1 class="text-dark mb-1">Welcome Back!</h1>
                      <p class="text-lead text-dark mb-3">Sign In Credential</p>
                    </div>
                    <div
                      v-show="error_obj.visible"
                      class="alert alert-danger text-white"
                      role="alert"
                    >
                      <small>{{ error_obj.message }}</small>
                    </div>
                    <Form @submit.prevent="signin">
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-text">
                            <i class="fa fa-user"></i>
                          </span>
                          <input
                            type="text"
                            class="form-control"
                            name="username"
                            id="username"
                            v-model="username"
                            placeholder="username"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-text">
                            <i class="fa fa-lock"></i>
                          </span>
                          <input
                            type="password"
                            class="form-control"
                            name="password"
                            id="password"
                            v-model="password"
                            placeholder="password"
                          />
                        </div>
                      </div>
                      <div class="text-center">
                        <input
                          class="btn btn-success bg-gradient-success w-100"
                          type="submit"
                          value="submit"
                        />
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </section>
  </div>
</template>

<script>
import logoWhite from "@/assets/img/logo_ip_putih.png";
import { ApiService } from "@/axios/apiService";

export default {
  name: "Signin",
  data() {
    return {
      logoWhite,
      username: "",
      password: "",
      error_obj: {
        visible: false,
        code: "",
        message: "",
      },
      apiService: new ApiService(),
    };
  },
  methods: {
    signin() {
      this.apiService
        .signin(this.username, this.password)
        .then((res) => {
          this.error_obj.visible = false;
          localStorage.setItem("user", res.data.accessToken);
          localStorage.setItem("group_data", JSON.stringify(res.data.group_data));
          this.$store.dispatch("user", res.data.user.name);
        })
        .then(() => {
          this.$router.push({ path: "/dashboard" }).then(() => {
            this.$router.go();
          });
        })
        .catch((error) => { 
          this.error_obj.visible = true;
          // console.log(error);
          this.error_obj.code = error.response.data.statusCode;
          if (typeof error.response.data.message === "string") {
            this.error_obj.message = error.response.data.message;
          } else {
            this.error_obj.message = error.response.data.message.join(", ");
          }
        });
    },
  },
  beforeMount() {
    if (localStorage.getItem("user")) {
      this.$store.state.showSidenav = true;
      this.$store.state.showNavbar = true;
      this.$store.state.showFooter = true;
      this.$router.push("/");
    }
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = false;
  },
};
</script>

<style>
.card-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
